<template>
  <div>
    <v-row align="center">
      <v-col cols="12">
        <j-date-picker
          :value="date"
          solo
          solo-inverted
          hide-details
          label="Sélectionner une date pour afficher l'inventaire"
          @input="v => $emit('update:date', v)"
        ></j-date-picker>
      </v-col>
    </v-row>
    <section v-if="date">
      <v-row align="center">
        <v-col cols="12">
          <InventoryTemplateEditor
            v-model="templateId"
            :template.sync="template"
          ></InventoryTemplateEditor>
        </v-col>
      </v-row>
      <InventoryRecordViewer
        :template="template"
        :records="records"
        manual-records
        read-only
      ></InventoryRecordViewer>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/api";
import { InventoryTemplateEditor, InventoryRecordViewer } from "../components";
export default {
  name: "InventoryHistory",
  props: {
    date: {
      required: true
    }
  },
  components: {
    InventoryTemplateEditor,
    InventoryRecordViewer
  },
  computed: {
    ...mapGetters([
      "getOrganisationId",
      "getStoreId",
      "getProducts",
      "getInventoryTemplates"
    ])
  },
  data() {
    return {
      templateId: null,
      template: [],
      records: []
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("startLoadingOverlay");
        this.records = await api.getInventoryRecords({
          store: this.getStoreId,
          date: this.date,
          latest: true
        });
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    }
  },
  watch: {
    date() {
      this.getData();
    },
    templateId(v) {
      if (v && v !== null) {
        this.template = this.getInventoryTemplates.find(
          x => x.id === v
        ).templates;
      } else {
        this.template = [];
      }
    }
  }
};
</script>

<style></style>
